import { HandHeart } from "lucide-react";
import { getPrayers } from "@/lib/api";
import { formatSmartDate } from "@/lib/date";

const prayersProvider = {
  id: "oraciones",
  label: "Oraciones",
  icon: HandHeart,
  iconBg: "bg-rose-50",
  iconColor: "text-rose-600",
  fields: ["text", "category", "status"],
  load: (districtId) => getPrayers({ district_id: districtId }),
  buildItem: (p) => ({
    id: p.id,
    title: p.text,
    subtitle: formatSmartDate(p.date || p.created_at),
    route: `/prayers/${p.id}/edit`,
    recent: null,
  }),
};

export default prayersProvider;
